import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P37-E1",
    audio: "img/FriendsPlus/Page37/Audio/audio-e1-p37.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page37/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/tieude-e1-p37.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page37/E1/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page37/E1/5.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/6.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/cl.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/7.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/8.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/gl.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/9.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/10.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/sl.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/11.jpg" },
      ],
      [
        // Column4
        { url: "img/FriendsPlus/Page37/E1/12.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/13.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/cloud.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/14.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/15.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/clock.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/16.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/17.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/gloves.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/18.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/19.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/glue.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/20.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/21.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/slide.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/22.jpg" },
        {
          url: "img/FriendsPlus/Page37/E1/23.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/slippers.mp3",
        },
        { url: "img/FriendsPlus/Page37/E1/24.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page37/E1/25.jpg" }],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P37-E2",
    audio: "img/FriendsPlus/Page37/Audio/audio-e2-p37.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page37/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page37/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page37/Audio/tieude-e2-p37.mp3",
        },
        { url: "img/FriendsPlus/Page37/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page37/E2/4.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: 'Unit 5',
    id: 'SB3-U5-P37-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page37/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read the chant again. Circle the sounds cl, gl, and sl.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        listWords: [
          'I ta|ke of|f my sl|ippers,',//0
          'I go ou|tside.',//1
          'I pu|t on my gl|oves,',//2
          'An|d I pl|ay on th|e sl|ide.',//3
          'I lo|ok at th|e cl|ock,',//4
          'I se|e cl|ouds in th|e sk|y.',//5
          'Ti|me to ta|ke of|f my gl|oves,',//6
          'Ti|me to sa|y, "Go|odbye."',//7
        ],
        answers: ['0-12', '2-10', '3-16', '4-12', '5-6', '6-16'],
        initialValue: ['0-12'],
      },
      Layout: `
        <div style='display: flex; flex-direction: row;position: relative;align-items: center;background-color: #fde9bc; padding: 20px;'>
          <div style='width: 50%; margin-left: 20px; color: #ec870e;text-align: center;'>
            <div><input id='0' type='Circle' /></div>
            <div><input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <div><input id='4' type='Circle' /></div>
            <div><input id='5' type='Circle' /></div>
            <div><input id='6' type='Circle' /></div>
            <div><input id='7' type='Circle' /></div>
          </div>
          <div style='width: '50%'>
            <img src="img/FriendsPlus/Page37/E3/title.jpg" style="width: 100%">
          </div>
        </div>
      `,
    },
  },
  4: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P37-E4",
    audio: "img/FriendsPlus/Page37/Audio/audio-e4-p37.mp3",
    video: "",
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page37/E4/Key/answerKey.png',
    inputSize: 300,
    checkUppercase: true,
    titleImage: "",
    backgroundColor: 'transparent',
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Listen to the sounds and connect the letters. <headphone name="57" src="img/FriendsPlus/Page37/Audio/tieude-e4-p37.mp3"></headphone>' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <div>What does the girl have? #</div>
            <img src="img/FriendsPlus/Page37/E4/title.jpg" style="width: 100%">
          </div>
        `,
        answer: ['The girl has slippers.'],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 5",
    id: "SB3-U5-P37-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page37/E5/1.jpg" }]],
  },
};

export default json;
